import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, EmptyState, Skeleton, Tabs } from "../components/ui";
import { useAsync } from "../hooks";
import { useToast } from "../context/ToastContext";
import { useI18n } from "../services/i18n";
import content from "../services/api-content";
import "../styles/content.css";

const CATS = [
  { value: "all", label: "ทั้งหมด" }, { value: "system", label: "ประกาศ" }, { value: "character", label: "ตัวละคร" }, { value: "comment", label: "ความคิดเห็น" },
  { value: "follower", label: "ผู้ติดตาม" }, { value: "social", label: "โซเชียล" }, { value: "report", label: "รายงาน" },
];
const ICON = { system: "📢", character: "🎭", comment: "💬", follower: "👤", social: "📝", report: "🚩", message: "✉️" };

export default function Notifications() {
  const navigate = useNavigate();
  const toast = useToast();
  const { t } = useI18n();
  const [cat, setCat] = useState("all");
  const { data, loading, error, reload } = useAsync(() => content.notifications.list(cat), [cat]);
  const rows = (data?.items || []).filter((n) => cat === "all" || n.category === cat);

  const readAll = async () => {
    try { await content.notifications.readAll(); toast("อ่านทั้งหมดแล้ว", "success"); reload(); } catch (e) { toast(e.message, "error"); }
  };
  const open = async (n) => {
    if (!n.isRead) content.notifications.read(n.id).then(reload).catch(() => {});
    if (n.link && n.link.startsWith("/")) navigate(n.link);
  };
  return (
    <div style={{ maxWidth: 680, margin: "0 auto" }}>
      <div className="page-head"><div><h1>{t("แจ้งเตือน")}</h1>{data ? <p>{data.unread ? `ยังไม่ได้อ่าน ${data.unread} รายการ` : "อ่านครบแล้ว"}</p> : null}</div><Button size="sm" onClick={readAll} disabled={!data?.unread}>{t("อ่านทั้งหมด")}</Button></div>
      <Tabs tabs={CATS.map((c) => ({ ...c, label: t(c.label) }))} value={cat} onChange={setCat} />
      <div className="stack mt-16">
        {error ? <EmptyState icon="⚠️" title="โหลดแจ้งเตือนไม่สำเร็จ" action={<Button onClick={reload}>ลองใหม่</Button>}><span className="error-text">{error}</span></EmptyState>
          : loading ? Array.from({ length: 3 }, (_, i) => <Skeleton key={i} height={74} radius={16} />)
          : !rows.length ? <EmptyState icon="🔔" title="ไม่มีการแจ้งเตือน">เมื่อมีกิจกรรมใหม่ จะแสดงที่นี่</EmptyState>
          : rows.map((n) => (
            <button key={n.id} type="button" onClick={() => open(n)} style={{ all: "unset", cursor: "pointer", display: "block" }} aria-label={`${n.title}${n.isRead ? "" : " (ยังไม่ได้อ่าน)"}`}>
              <Card link className="row" style={{ borderColor: n.isRead ? undefined : "var(--primary)", alignItems: "flex-start" }}>
                <span style={{ fontSize: 24 }} aria-hidden="true">{ICON[n.category] || "🔔"}</span>
                <div className="grow"><div className="strong">{n.title}</div><div className="muted">{n.body}</div>
                  <div className="faint mt-8" style={{ fontSize: 12 }}>{new Date(n.createdAt).toLocaleString("th-TH", { dateStyle: "medium", timeStyle: "short" })}</div></div>
                {!n.isRead ? <span className="pill pill--ok">ใหม่</span> : null}
              </Card>
            </button>
          ))}
      </div>
    </div>
  );
}
